import i18next from "../i18n";

export const AUTH_UID = "Uid";
export const USER_TOKEN = "USER_TOKEN";
export const USER_NAME = "USER_NAME";
// export const USER_INFO = "USER_INFO";
export const USER_PHONE = "USER_PHONE";
export const SESSION_ID = "SESSION_ID";
export const REQUEST_TOKEN = "Authorization";
export const CHAT_TYPE = "CHAT_TYPE";
export const SHOW_USER_WATERMARK = "SHOW_USER_WATERMARK";
export const WATERMARK_TEXT = "WATERMARK_TEXT";
export const MODEL_SWITCH = "MODEL_SWITCH";

// export const ClLIPBOARD_APPEDNEDED_TEMP  = `\n链接：{0}\n来源：商汤商量大语言模型\n此内容为使用深度合成技术生成的文本信息，严禁复制、传播、用于不良目的，一切后果由使用者自负。请遵守法律法规和道德准则，不要滥用深度合成技术，共同维护信息安全和社会稳定。`
export const ClLIPBOARD_APPEDNEDED_TEMP =
  i18next.t("sensechat-101", { link: "{0}", enter: "\n" }) || "";

export const FORM_VALIDATE_REQUIRED = i18next.t("sensechat-171"); // '必填项，请输入'

export const REGIONS = {
  mainland: "86",
  hongkong: "852",
  macao: "853",
  taiwan: "886",
  singapore: "0065",
  malaysia: "0060",
};

export const PHONE_PATTERNS: Record<string, any> = {
  [REGIONS.mainland]: /^1\d{10}$/, // 1开头后面跟10位数字
  // [REGIONS.hongkong]: /^([6|9])\d{7}$/, // 9或6开头后面跟7位数字
  [REGIONS.hongkong]: /^([569]\d{7}|188\d{5})$/, // 9或6或588开头的8位数字
  [REGIONS.macao]: /^[6]([8|6])\d{5}$/, // 66或68开头后面跟5位数字
  [REGIONS.taiwan]: /^[0][9]\d{8}$/, // 09开头后面跟8位数字
  [REGIONS.singapore]: /^([8|9])\d{7}$/, // 一般为8位数，8，9开头的
  [REGIONS.malaysia]: /^1\d{8,9}$/, //马来西亚
};

export const PASSWORD_REG =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]+$/;

export const LANG = [
  {
    value: "zh_CN",
    name: "简体中文",
    alias: "简",
  },
  {
    value: "zh_HK",
    name: "繁体中文",
    alias: "繁",
  },
  {
    value: "en",
    name: "English",
    alias: "En",
  },
];
